export default __webpack_public_path__ + "static/media/adminbackgroundtror.94855dab.png";